"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _react = _interopRequireDefault(require("react"));
var _isNil2 = _interopRequireDefault(require("lodash/isNil"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = function _default(settings) {
  return function (_ref) {
    var value = _ref.value,
      row = _ref.row;
    var yValue = '';
    var sum = 0;
    row[settings.namePath].map(function (item) {
      var v = "".concat((0, _get2["default"])(item, settings.valuePath));
      if (!(0, _isNil2["default"])(v) && v !== 'null') {
        sum += +v;
      }
      return sum;
    });
    if (settings.yValue) {
      yValue = settings.yValue;
    } else if (settings.yPath) {
      yValue = (0, _get2["default"])(row, settings.yPath);
    }
    if ((0, _isNil2["default"])(yValue)) {
      return /*#__PURE__*/_react["default"].createElement("div", null);
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('table-renderers-xofy')
    }, /*#__PURE__*/_react["default"].createElement("span", null, sum >= 0 ? /*#__PURE__*/_react["default"].createElement("span", null, sum) : /*#__PURE__*/_react["default"].createElement("span", {
      className: "text-center"
    })), "/", /*#__PURE__*/_react["default"].createElement("span", null, yValue));
  };
};